import { ClientApiProps } from "../common";

export async function getDraftSubmissions(props: ClientApiProps) {
  return [];
}

export async function getPreviousSubmissions(search: string, props: ClientApiProps) {
  return [];
}